import { GET_DATA_FILTERREPORT_PLANTYPE_SUCCEEDED, REQUEST_FILTERREPORT_PLANTYPE_FAILED, CLEAR_DATA_FILTERREPORT_PLANTYPE} from '../actions/actionTypes'

const filterReportReducer = (DataFilterReport = [], actions) => {
    switch (actions.type) {
        case CLEAR_DATA_FILTERREPORT_PLANTYPE:
            return {...DataFilterReport,DataFilterReport: []}
        case GET_DATA_FILTERREPORT_PLANTYPE_SUCCEEDED:
            if(Object.keys(actions.DataFilterReport).length > 0)
            {
                return {...DataFilterReport, DataFilterReport: actions.DataFilterReport};
            }
            else
            {
                return {...DataFilterReport};
            }
        case REQUEST_FILTERREPORT_PLANTYPE_FAILED:
            return {...DataFilterReport,DataFilterReport: []};
        default:
            return {...DataFilterReport};
    }
}

export default filterReportReducer;